"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spoiler = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const slate_1 = require("slate");
const slate_react_1 = require("slate-react");
const context_1 = require("../../context");
const blockClass = (0, nano_theme_1.drule)({
    bg: '#222',
    col: 'transparent',
});
const radius = 'calc(min(3px,.15em))';
const startClass = (0, nano_theme_1.rule)({
    borderTopLeftRadius: radius,
    borderBottomLeftRadius: radius,
});
const endClass = (0, nano_theme_1.rule)({
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius,
});
const Spoiler = (props) => {
    const { text, children } = props;
    const theme = (0, nano_theme_1.useTheme)();
    const mutxt = (0, context_1.useMuTxt)();
    const selection = (0, slate_react_1.useSlateSelection)();
    let isRevealed = false;
    if (selection && slate_1.Range.isCollapsed(selection)) {
        try {
            const path = slate_react_1.ReactEditor.findPath(mutxt.editor, text);
            if (slate_1.Path.equals(selection.anchor.path, path))
                isRevealed = true;
        }
        catch { }
    }
    const className = blockClass({
        bg: isRevealed ? theme.g(0.2, 0.1) : '#222',
        col: isRevealed ? 'inherit' : 'transparent',
        '& *': {
            col: isRevealed ? 'inherit' : 'transparent',
        },
    }) +
        startClass +
        endClass;
    return React.createElement("span", { className: className }, children);
};
exports.Spoiler = Spoiler;
